/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from 'react';
import { KTIcon } from '../../../../_metronic/helpers'
import { StepProps } from '../ISignupModels'

const Step1 = ({ data, updateData, hasError }: StepProps) => {

  return (
    <div className="flex-column current" data-kt-stepper-element='content'>
      <div className="d-flex flex-column flex-lg-row-fluid py-0">
        <div className="card card-flush h-xl-100">
          <div className="card-header pt-6 ps-0">
            <h3 className="card-title align-items-start flex-column">
              <span className="card-label fw-bold text-gray-800">Account utente</span>
              <span className="text-gray-400 mt-1 fw-semibold fs-6">Inserisci i dati e crea il tuo account</span>
            </h3>
          </div>
        </div>
        <div className='w-100'>
          {/*begin::Form Group */}
          <div className='row fv-row mt-4 mb-10'>
            <div className='col-md-6'>
              <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                <span className='required'>Nome</span>
              </label>
              <input
                type='text'
                className='form-control form-control-lg form-control-solid'
                name='firstname'
                placeholder='Inserisci il tuo nome'
                value={data.appBasic.firstname}
                onChange={(e) =>
                  updateData({
                    appBasic: {
                      ...data.appBasic,
                      firstname: e.target.value
                    },
                  })
                }
              />
              {!data.appBasic.firstname && hasError && (
                <div className='fv-plugins-message-container'>
                  <div data-field='firstname' data-validator='notEmpty' className='fv-help-block'>
                    Campo richiesto
                  </div>
                </div>
              )}
            </div>
            <div className='col-md-6'>
              <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                <span className='required'>Cognome</span>
              </label>
              <input
                type='text'
                className='form-control form-control-lg form-control-solid'
                name='surname'
                placeholder=''
                value={data.appBasic.surname}
                onChange={(e) =>
                  updateData({
                    appBasic: {
                      ...data.appBasic,
                      surname: e.target.value
                    },
                  })
                }
              />
              {!data.appBasic.surname && hasError && (
                <div className='fv-plugins-message-container'>
                  <div data-field='surname' data-validator='notEmpty' className='fv-help-block'>
                    Campo richiesto
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className='row fv-row mb-10'>
            <div className='col-md-6'>
              <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                <span className='required'>Email</span>
              </label>
              <input
                type='email'
                className='form-control form-control-lg form-control-solid'
                name='email'
                placeholder=''
                value={data.appBasic.email}
                onChange={(e) =>
                  updateData({
                    appBasic: {
                      ...data.appBasic,
                      email: e.target.value
                    },
                  })
                }
              />
              {!data.appBasic.email && hasError && (
                <div className='fv-plugins-message-container'>
                  <div data-field='email' data-validator='notEmpty' className='fv-help-block'>
                    Campo richiesto
                  </div>
                </div>
              )}
            </div>
            <div className='col-md-6'>
              <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                <span className='required'>Telefono/Cellulare</span>
              </label>
              <input
                type='tel'
                className='form-control form-control-lg form-control-solid'
                name='phone'
                placeholder=''
                value={data.appBasic.phone}
                onChange={(e) =>
                  updateData({
                    appBasic: {
                      ...data.appBasic,
                      phone: e.target.value
                    },
                  })
                }
              />
              {!data.appBasic.phone && hasError && (
                <div className='fv-plugins-message-container'>
                  <div data-field='phone' data-validator='notEmpty' className='fv-help-block'>
                    Campo richiesto
                  </div>
                </div>
              )}
            </div>

          </div>
          <div className='row fv-row mb-10'>
            <div className='col-md-6'>
              <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                <span className='required'>Password</span>
              </label>
              <input
                type='password'
                className='form-control form-control-lg form-control-solid'
                name='password'
                placeholder=''
                value={data.appBasic.password}
                onChange={(e) =>
                  updateData({
                    appBasic: {
                      ...data.appBasic,
                      password: e.target.value
                    },
                  })
                }
              />
              {!data.appBasic.password && hasError && (
                <div className='fv-plugins-message-container'>
                  <div data-field='password' data-validator='notEmpty' className='fv-help-block'>
                    Campo richiesto
                  </div>
                </div>
              )}
            </div>
            <div className='col-md-6'>
              <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                <span className='required'>Conferma Password</span>
              </label>
              <input
                type='password'
                className='form-control form-control-lg form-control-solid'
                name='password-confirm'
                placeholder=''
                value={data.appBasic.passwordConfirm}
                onChange={(e) =>
                  updateData({
                    appBasic: {
                      ...data.appBasic,
                      passwordConfirm: e.target.value
                    },
                  })
                }
              />
              {data.appBasic.password !== data.appBasic.passwordConfirm && hasError && (
                <div className='fv-plugins-message-container'>
                  <div data-field='password-confirm' data-validator='notEmpty' className='fv-help-block'>
                    Le password non corrispondono
                  </div>
                </div>
              )}
            </div>
          </div>
          {/*end::Form Group */}
        </div>
      </div>

      <div className="d-flex flex-column flex-lg-row-fluid py-0">
        <div className="card card-flush h-xl-100">
          <div className="card-header pt-6 ps-0">
            <h3 className="card-title align-items-start flex-column">
              <span className="card-label fw-bold text-gray-800">Dati azienda</span>
              <span className="text-gray-400 mt-1 fw-semibold fs-6">Inserisci i dati della tua azienda</span>
            </h3>
          </div>
        </div>
        <div className='w-100'>
          {/*begin::Form Group */}
          <div className='row fv-row mt-4 mb-10'>
            <div className='col-md-6'>
              <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                <span className='required'>Nome azienda</span>
              </label>
              <input
                type='text'
                className='form-control form-control-lg form-control-solid'
                name='company'
                placeholder='Es. Company Srl'
                value={data.appBasic.company}
                onChange={(e) =>
                  updateData({
                    appBasic: {
                      ...data.appBasic,
                      company: e.target.value
                    },
                  })
                }
              />
              {!data.appBasic.company && hasError && (
                <div className='fv-plugins-message-container'>
                  <div data-field='company' data-validator='notEmpty' className='fv-help-block'>
                    Campo richiesto
                  </div>
                </div>
              )}
            </div>
            <div className='col-md-6'>
              <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                <span className='required'>P.IVA</span>
              </label>
              <input
                type='text'
                className='form-control form-control-lg form-control-solid'
                name='vatNumber'
                placeholder=''
                value={data.appBasic.vatNumber}
                onChange={(e) =>
                  updateData({
                    appBasic: {
                      ...data.appBasic,
                      vatNumber: e.target.value
                    },
                  })
                }
              />
              {!data.appBasic.vatNumber || hasError && (
                <div className='fv-plugins-message-container'>
                  <div data-field='vatNumber' data-validator='notEmpty' className='fv-help-block'>
                    Campo richiesto o non valido
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className='row fv-row mb-10'>
            <div className='col-md-6'>
              <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                <span className='required'>Indirizzo</span>
              </label>
              <input
                type='text'
                className='form-control form-control-lg form-control-solid'
                name='address'
                placeholder=''
                value={data.appBasic.address}
                onChange={(e) =>
                  updateData({
                    appBasic: {
                      ...data.appBasic,
                      address: e.target.value
                    },
                  })
                }
              />
              {!data.appBasic.address && hasError && (
                <div className='fv-plugins-message-container'>
                  <div data-field='address' data-validator='notEmpty' className='fv-help-block'>
                    Campo richiesto
                  </div>
                </div>
              )}
            </div>
            <div className='col-md-6'>
              <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                <span className='required'>Città</span>
              </label>
              <input
                type='text'
                className='form-control form-control-lg form-control-solid'
                name='city'
                placeholder=''
                value={data.appBasic.city}
                onChange={(e) =>
                  updateData({
                    appBasic: {
                      ...data.appBasic,
                      city: e.target.value
                    },
                  })
                }
              />
              {!data.appBasic.city && hasError && (
                <div className='fv-plugins-message-container'>
                  <div data-field='city' data-validator='notEmpty' className='fv-help-block'>
                    Campo richiesto
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className='row fv-row mb-10'>
            <div className='col-md-6'>
              <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                <span className='required'>CAP</span>
              </label>
              <input
                type='text'
                className='form-control form-control-lg form-control-solid'
                name='zipCode'
                placeholder=''
                value={data.appBasic.zipCode}
                onChange={(e) =>
                  updateData({
                    appBasic: {
                      ...data.appBasic,
                      zipCode: e.target.value
                    },
                  })
                }
              />
              {!data.appBasic.zipCode && hasError && (
                <div className='fv-plugins-message-container'>
                  <div data-field='zipCode' data-validator='notEmpty' className='fv-help-block'>
                    Campo richiesto
                  </div>
                </div>
              )}
            </div>
            <div className='col-md-6'>
              <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                <span className='required'>Nazione</span>
              </label>
              <select
                name='country'
                className='form-select form-select-solid form-select-lg fw-bold'
                value={data.appBasic.country}
                onChange={(e) =>
                  updateData({
                    appBasic: {
                      ...data.appBasic,
                      country: e.target.value
                    },
                  })
                }>
                <option value=''>Select a Country...</option>
                <option value='AF'>Afghanistan</option>
                <option value='AX'>Aland Islands</option>
                <option value='AL'>Albania</option>
                <option value='DZ'>Algeria</option>
                <option value='AS'>American Samoa</option>
                <option value='AD'>Andorra</option>
                <option value='AO'>Angola</option>
                <option value='AI'>Anguilla</option>
                <option value='AQ'>Antarctica</option>
                <option value='AG'>Antigua and Barbuda</option>
                <option value='AR'>Argentina</option>
                <option value='AM'>Armenia</option>
                <option value='AW'>Aruba</option>
                <option value='AU'>Australia</option>
                <option value='AT'>Austria</option>
                <option value='AZ'>Azerbaijan</option>
                <option value='BS'>Bahamas</option>
                <option value='BH'>Bahrain</option>
                <option value='BD'>Bangladesh</option>
                <option value='BB'>Barbados</option>
                <option value='BY'>Belarus</option>
                <option value='BE'>Belgium</option>
                <option value='BZ'>Belize</option>
                <option value='BJ'>Benin</option>
                <option value='BM'>Bermuda</option>
                <option value='BT'>Bhutan</option>
                <option value='BO'>Bolivia, Plurinational State of</option>
                <option value='BQ'>Bonaire, Sint Eustatius and Saba</option>
                <option value='BA'>Bosnia and Herzegovina</option>
                <option value='BW'>Botswana</option>
                <option value='BV'>Bouvet Island</option>
                <option value='BR'>Brazil</option>
                <option value='IO'>British Indian Ocean Territory</option>
                <option value='BN'>Brunei Darussalam</option>
                <option value='BG'>Bulgaria</option>
                <option value='BF'>Burkina Faso</option>
                <option value='BI'>Burundi</option>
                <option value='KH'>Cambodia</option>
                <option value='CM'>Cameroon</option>
                <option value='CA'>Canada</option>
                <option value='CV'>Cape Verde</option>
                <option value='KY'>Cayman Islands</option>
                <option value='CF'>Central African Republic</option>
                <option value='TD'>Chad</option>
                <option value='CL'>Chile</option>
                <option value='CN'>China</option>
                <option value='CX'>Christmas Island</option>
                <option value='CC'>Cocos (Keeling) Islands</option>
                <option value='CO'>Colombia</option>
                <option value='KM'>Comoros</option>
                <option value='CG'>Congo</option>
                <option value='CD'>Congo, the Democratic Republic of the</option>
                <option value='CK'>Cook Islands</option>
                <option value='CR'>Costa Rica</option>
                <option value='CI'>Côte d'Ivoire</option>
                <option value='HR'>Croatia</option>
                <option value='CU'>Cuba</option>
                <option value='CW'>Curaçao</option>
                <option value='CY'>Cyprus</option>
                <option value='CZ'>Czech Republic</option>
                <option value='DK'>Denmark</option>
                <option value='DJ'>Djibouti</option>
                <option value='DM'>Dominica</option>
                <option value='DO'>Dominican Republic</option>
                <option value='EC'>Ecuador</option>
                <option value='EG'>Egypt</option>
                <option value='SV'>El Salvador</option>
                <option value='GQ'>Equatorial Guinea</option>
                <option value='ER'>Eritrea</option>
                <option value='EE'>Estonia</option>
                <option value='ET'>Ethiopia</option>
                <option value='FK'>Falkland Islands (Malvinas)</option>
                <option value='FO'>Faroe Islands</option>
                <option value='FJ'>Fiji</option>
                <option value='FI'>Finland</option>
                <option value='FR'>France</option>
                <option value='GF'>French Guiana</option>
                <option value='PF'>French Polynesia</option>
                <option value='TF'>French Southern Territories</option>
                <option value='GA'>Gabon</option>
                <option value='GM'>Gambia</option>
                <option value='GE'>Georgia</option>
                <option value='DE'>Germany</option>
                <option value='GH'>Ghana</option>
                <option value='GI'>Gibraltar</option>
                <option value='GR'>Greece</option>
                <option value='GL'>Greenland</option>
                <option value='GD'>Grenada</option>
                <option value='GP'>Guadeloupe</option>
                <option value='GU'>Guam</option>
                <option value='GT'>Guatemala</option>
                <option value='GG'>Guernsey</option>
                <option value='GN'>Guinea</option>
                <option value='GW'>Guinea-Bissau</option>
                <option value='GY'>Guyana</option>
                <option value='HT'>Haiti</option>
                <option value='HM'>Heard Island and McDonald Islands</option>
                <option value='VA'>Holy See (Vatican City State)</option>
                <option value='HN'>Honduras</option>
                <option value='HK'>Hong Kong</option>
                <option value='HU'>Hungary</option>
                <option value='IS'>Iceland</option>
                <option value='IN'>India</option>
                <option value='ID'>Indonesia</option>
                <option value='IR'>Iran, Islamic Republic of</option>
                <option value='IQ'>Iraq</option>
                <option value='IE'>Ireland</option>
                <option value='IM'>Isle of Man</option>
                <option value='IL'>Israel</option>
                <option value='IT'>Italy</option>
                <option value='JM'>Jamaica</option>
                <option value='JP'>Japan</option>
                <option value='JE'>Jersey</option>
                <option value='JO'>Jordan</option>
                <option value='KZ'>Kazakhstan</option>
                <option value='KE'>Kenya</option>
                <option value='KI'>Kiribati</option>
                <option value='KP'>Korea, Democratic People's Republic of</option>
                <option value='KW'>Kuwait</option>
                <option value='KG'>Kyrgyzstan</option>
                <option value='LA'>Lao People's Democratic Republic</option>
                <option value='LV'>Latvia</option>
                <option value='LB'>Lebanon</option>
                <option value='LS'>Lesotho</option>
                <option value='LR'>Liberia</option>
                <option value='LY'>Libya</option>
                <option value='LI'>Liechtenstein</option>
                <option value='LT'>Lithuania</option>
                <option value='LU'>Luxembourg</option>
                <option value='MO'>Macao</option>
                <option value='MK'>Macedonia, the former Yugoslav Republic of</option>
                <option value='MG'>Madagascar</option>
                <option value='MW'>Malawi</option>
                <option value='MY'>Malaysia</option>
                <option value='MV'>Maldives</option>
                <option value='ML'>Mali</option>
                <option value='MT'>Malta</option>
                <option value='MH'>Marshall Islands</option>
                <option value='MQ'>Martinique</option>
                <option value='MR'>Mauritania</option>
                <option value='MU'>Mauritius</option>
                <option value='YT'>Mayotte</option>
                <option value='MX'>Mexico</option>
                <option value='FM'>Micronesia, Federated States of</option>
                <option value='MD'>Moldova, Republic of</option>
                <option value='MC'>Monaco</option>
                <option value='MN'>Mongolia</option>
                <option value='ME'>Montenegro</option>
                <option value='MS'>Montserrat</option>
                <option value='MA'>Morocco</option>
                <option value='MZ'>Mozambique</option>
                <option value='MM'>Myanmar</option>
                <option value='NA'>Namibia</option>
                <option value='NR'>Nauru</option>
                <option value='NP'>Nepal</option>
                <option value='NL'>Netherlands</option>
                <option value='NC'>New Caledonia</option>
                <option value='NZ'>New Zealand</option>
                <option value='NI'>Nicaragua</option>
                <option value='NE'>Niger</option>
                <option value='NG'>Nigeria</option>
                <option value='NU'>Niue</option>
                <option value='NF'>Norfolk Island</option>
                <option value='MP'>Northern Mariana Islands</option>
                <option value='NO'>Norway</option>
                <option value='OM'>Oman</option>
                <option value='PK'>Pakistan</option>
                <option value='PW'>Palau</option>
                <option value='PS'>Palestinian Territory, Occupied</option>
                <option value='PA'>Panama</option>
                <option value='PG'>Papua New Guinea</option>
                <option value='PY'>Paraguay</option>
                <option value='PE'>Peru</option>
                <option value='PH'>Philippines</option>
                <option value='PN'>Pitcairn</option>
                <option value='PL'>Poland</option>
                <option value='PT'>Portugal</option>
                <option value='PR'>Puerto Rico</option>
                <option value='QA'>Qatar</option>
                <option value='RE'>Réunion</option>
                <option value='RO'>Romania</option>
                <option value='RU'>Russian Federation</option>
                <option value='RW'>Rwanda</option>
                <option value='BL'>Saint Barthélemy</option>
                <option value='SH'>Saint Helena, Ascension and Tristan da Cunha</option>
                <option value='KN'>Saint Kitts and Nevis</option>
                <option value='LC'>Saint Lucia</option>
                <option value='MF'>Saint Martin (French part)</option>
                <option value='PM'>Saint Pierre and Miquelon</option>
                <option value='VC'>Saint Vincent and the Grenadines</option>
                <option value='WS'>Samoa</option>
                <option value='SM'>San Marino</option>
                <option value='ST'>Sao Tome and Principe</option>
                <option value='SA'>Saudi Arabia</option>
                <option value='SN'>Senegal</option>
                <option value='RS'>Serbia</option>
                <option value='SC'>Seychelles</option>
                <option value='SL'>Sierra Leone</option>
                <option value='SG'>Singapore</option>
                <option value='SX'>Sint Maarten (Dutch part)</option>
                <option value='SK'>Slovakia</option>
                <option value='SI'>Slovenia</option>
                <option value='SB'>Solomon Islands</option>
                <option value='SO'>Somalia</option>
                <option value='ZA'>South Africa</option>
                <option value='GS'>South Georgia and the South Sandwich Islands</option>
                <option value='KR'>South Korea</option>
                <option value='SS'>South Sudan</option>
                <option value='ES'>Spain</option>
                <option value='LK'>Sri Lanka</option>
                <option value='SD'>Sudan</option>
                <option value='SR'>Suriname</option>
                <option value='SJ'>Svalbard and Jan Mayen</option>
                <option value='SZ'>Swaziland</option>
                <option value='SE'>Sweden</option>
                <option value='CH'>Switzerland</option>
                <option value='SY'>Syrian Arab Republic</option>
                <option value='TW'>Taiwan, Province of China</option>
                <option value='TJ'>Tajikistan</option>
                <option value='TZ'>Tanzania, United Republic of</option>
                <option value='TH'>Thailand</option>
                <option value='TL'>Timor-Leste</option>
                <option value='TG'>Togo</option>
                <option value='TK'>Tokelau</option>
                <option value='TO'>Tonga</option>
                <option value='TT'>Trinidad and Tobago</option>
                <option value='TN'>Tunisia</option>
                <option value='TR'>Turkey</option>
                <option value='TM'>Turkmenistan</option>
                <option value='TC'>Turks and Caicos Islands</option>
                <option value='TV'>Tuvalu</option>
                <option value='UG'>Uganda</option>
                <option value='UA'>Ukraine</option>
                <option value='AE'>United Arab Emirates</option>
                <option value='GB'>United Kingdom</option>
                <option value='US'>United States</option>
                <option value='UY'>Uruguay</option>
                <option value='UZ'>Uzbekistan</option>
                <option value='VU'>Vanuatu</option>
                <option value='VE'>Venezuela, Bolivarian Republic of</option>
                <option value='VN'>Vietnam</option>
                <option value='VI'>Virgin Islands</option>
                <option value='WF'>Wallis and Futuna</option>
                <option value='EH'>Western Sahara</option>
                <option value='YE'>Yemen</option>
                <option value='ZM'>Zambia</option>
                <option value='ZW'>Zimbabwe</option>
              </select>

              {!data.appBasic.country && hasError && (
                <div className='fv-plugins-message-container'>
                  <div data-field='country' data-validator='notEmpty' className='fv-help-block'>
                    Campo richiesto
                  </div>
                </div>
              )}
            </div>
          </div>
          {/*end::Form Group */}
        </div>
      </div>
    </div>
  );
};

export { Step1 };